import { useState as p, useRef as m, useEffect as f } from "react";
const z = ({
  threshold: e = 1024,
  overThresholdCollapsed: i,
  underThresholdCollapsed: s
}) => {
  const o = () => window.innerWidth >= e ? i : s, [w, r] = p(o()), n = m(window.innerWidth);
  return f(() => {
    const t = (W, a) => {
      const d = o(), u = n.current < e && window.innerWidth >= e, c = n.current >= e && window.innerWidth < e;
      (a || u || c) && r(d), n.current = window.innerWidth;
    };
    return window.addEventListener("resize", t), t(null, !0), () => {
      window.removeEventListener("resize", t);
    };
  }, [e, i, s]), [w, r];
};
export {
  z as u
};
